/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Blog_TitleInputs */

const en_landing_blog_title = /** @type {(inputs: Landing_Blog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From the blog`)
};

const zh_landing_blog_title = /** @type {(inputs: Landing_Blog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新博客`)
};

/**
* | output |
* | --- |
* | "From the blog" |
*
* @param {Landing_Blog_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_blog_title = /** @type {((inputs?: Landing_Blog_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Blog_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_blog_title(inputs)
	return zh_landing_blog_title(inputs)
});
export { landing_blog_title as "landing.blog.title" }